import { Injectable,
    Inject, 
    Input,
    ElementRef,
    OnChanges,
    SimpleChanges,
    Directive, 
    Provider, 
    PLATFORM_ID,
    Renderer2,
    NgModule, 
    ModuleWithProviders, 
   } from '@angular/core';

import { ɵDomAdapter as DomAdapter, DOCUMENT, ɵgetDOM as getDOM} from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { Cookie } from './cookie.service';

export const EXPERIMENTS:any = '';

export class ExperimentModel{
experimentName: string;
versions: any;

constructor(name:string, versions:any){
   this.experimentName = name;
   this.versions = versions;
}
}

export abstract class ABTestingSelectionStrategy{
abstract selectVersionDisplayed(experimentName:string):any;
}

@Injectable()
export class RandomStrategy implements ABTestingSelectionStrategy{
constructor(@Inject(EXPERIMENTS) private experiments:ExperimentModel[]){}
selectVersionDisplayed(experimentName:string):string{
   let experiment = this.experiments.find(e => {
       return e.experimentName == experimentName;
   });
   if(!experiment){
       throw Error(`${experimentName} are not registered`);
   }
   let randomVersion = this.pickRandomVersion(experiment.versions);
   return  randomVersion;
}

private pickRandomVersion(versions) {
   var result;
   var count = 0;
   for (var v in versions)
       if (Math.random() < 1/++count)
           result = v;
   return result;
}
}

@Injectable()
export class RandomWeightedStrategy implements ABTestingSelectionStrategy{
constructor(@Inject(EXPERIMENTS) private experiments:ExperimentModel[]){}
selectVersionDisplayed(experimentName:string):string{
   let experiment = this.experiments.find(e => {
       return e.experimentName == experimentName;
   });
   if(!experiment){
       throw Error(`${experimentName} are not registered`)
   }
   return this.weightedRandom(experiment.versions);
}

private weightedRandom(weights):string{
   let sum = 0;
   let r = Math.random()*100;

   for(let i in weights){
       sum += weights[i];
       if(r <= sum) 
       {
           return i;
       }
   }
}
}
export interface ExperimentModuleConfig {
experimentName: string;
versions?: any;
}
export interface ABTestingModuleConfig {
strategy?: Provider;
experiments: ExperimentModuleConfig[];
}

@Directive({
selector: '[abTesting]',
host:{
   "[attr.abvalue]": "version"
},
exportAs: 'abtesting'
})
export class ABTestingDirective implements OnChanges{
private isBrowser:boolean = true;
public version:string;
private _dom: DomAdapter;
private experimentName:string;
@Input() set abTesting(v:string){
   this.experimentName = v;
   this.__initFunction();
}
@Input('abStyleRules') styleRules:any = {};
@Input('abClassRules') classRules:any = {};
@Input('abHidden') hiddenRules:any = {};


constructor(@Inject(DOCUMENT) private _doc: any, private strategy:ABTestingSelectionStrategy, 
@Inject(PLATFORM_ID) platformId:Object,   private elementRef:ElementRef, private renderer:Renderer2,
private cookie: Cookie){
   this.isBrowser = isPlatformBrowser(platformId);
}

private __initFunction(){
   if(this.isBrowser){
       let expire = new Date();
       expire = new Date(expire.getTime()+7*24*60*60*1000);
       this.version = this.parse(document.cookie)[`AB_${this.experimentName}`] || this.strategy.selectVersionDisplayed(this.experimentName);
       document.cookie = `AB_${this.experimentName} = ${this.version}; path = /; expires=${expire.toUTCString()}`;
   }else{
       if (this.cookie.getAll() && this.cookie.getAll()[`AB_${this.experimentName}`]){
           this.version = this.cookie.getAll()[`AB_${this.experimentName}`];
       }
       else 
       {
            this.version = this.strategy.selectVersionDisplayed(this.experimentName);
            this.cookie.put(`AB_${this.experimentName}`, this.version);            
       }
   }
}

ngOnChanges(change:SimpleChanges){
   //TODO: USAR RENDERDER2, no acceder al nativeElement directamente. Lo he corregido por ahora en servidor.
    if(this.isBrowser){
       if(this.styleRules[this.version]){            
            this.elementRef.nativeElement.setAttribute("style", this.styleRules[this.version]);
       }
       
       if(this.classRules[this.version]){
           this.classRules[this.version].split(" ").forEach(_clazz => {
               this.elementRef.nativeElement.classList.add(_clazz)
           });
       }

       if(this.hiddenRules[this.version]){
           this.elementRef.nativeElement.remove();
       }
   }else{
       if(this.styleRules[this.version]){
           this.renderer.setAttribute(this.elementRef.nativeElement, 'style', this.styleRules[this.version]);
       }

       if(this.classRules[this.version]){
           this.renderer.addClass(this.elementRef.nativeElement, this.classRules[this.version]);
       }

       if(this.hiddenRules[this.version]){
           this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
       }
   }
}

private parse(str:string):any {
   var decode = decodeURIComponent;
   var obj = {};
   if(str){
       var pairs = str.split(/ *; */);
       var pair;
       if ('' == pairs[0]) return obj;
       for (var i = 0; i < pairs.length; ++i) {
           pair = pairs[i].split('=');
           obj[decode(pair[0])] = decode(pair[1]);
       }
   }
   return obj;
}
}

declare var ga;

@NgModule({
providers: [],
declarations: [
   ABTestingDirective
],
exports: [
   ABTestingDirective
]
})
export class ABTestingModule{
private static parse(str:string):any {
   var decode = decodeURIComponent;
   var obj = {};
   if(str){
       var pairs = str.split(/ *; */);
       var pair;
       if ('' == pairs[0]) return obj;
       for (var i = 0; i < pairs.length; ++i) {
           pair = pairs[i].split('=');
           obj[decode(pair[0])] = decode(pair[1]);
       }
   }
   return obj;
}
static withConfig(config:ABTestingModuleConfig):ModuleWithProviders  {
   return {
       ngModule: ABTestingModule,
       providers: [
           config.strategy || { provide: ABTestingSelectionStrategy, useClass: RandomStrategy },
           {provide: EXPERIMENTS, useValue: config.experiments },
       ]
   }
}
}

